
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class PsMemberTypeDialog extends Serenity.EntityDialog<PsMemberTypeRow, any> {
        protected getFormKey() { return PsMemberTypeForm.formKey; }
        protected getIdProperty() { return PsMemberTypeRow.idProperty; }
        protected getLocalTextPrefix() { return PsMemberTypeRow.localTextPrefix; }
        protected getNameProperty() { return PsMemberTypeRow.nameProperty; }
        protected getService() { return PsMemberTypeService.baseUrl; }
        protected getDeletePermission() { return PsMemberTypeRow.deletePermission; }
        protected getInsertPermission() { return PsMemberTypeRow.insertPermission; }
        protected getUpdatePermission() { return PsMemberTypeRow.updatePermission; }

        protected form = new PsMemberTypeForm(this.idPrefix);

        constructor() {
            super();

            this.form.MbPriceFg.element.parent();

            this.form.MbPriceFg.change(e => {
               var type =  this.form.MbPriceFg.value;
             
               if (type == MbPriceFg.PresentDiscount.toString()) {
                   Serenity.EditorUtils.setReadOnly(this.form.SellUnitPriceNo, true);
                   Serenity.EditorUtils.setReadOnly(this.form.MbDiscPs, false);
               }
               else if (type == MbPriceFg.MemberPrice.toString()){
                Serenity.EditorUtils.setReadOnly(this.form.SellUnitPriceNo, false);
                Serenity.EditorUtils.setReadOnly(this.form.MbDiscPs, true);
               }
               else if (type == MbPriceFg.SaleDiscount.toString()){
                Serenity.EditorUtils.setReadOnly(this.form.SellUnitPriceNo, true);
                Serenity.EditorUtils.setReadOnly(this.form.MbDiscPs, false);
               }
            });
        }


    }
}